import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { registerUnauthorizedHandler } from "./api";
import "./index.css";

export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: false } },
});

// A 401 anywhere clears cached tenant data and bounces the user to
// /login so a stale token can't leave the UI in an "empty-with-red-errors"
// stuck state.
registerUnauthorizedHandler(() => {
  queryClient.clear();
  if (window.location.pathname !== "/login" && window.location.pathname !== "/signup") {
    const back = window.location.pathname + window.location.search;
    window.location.assign(`/login?next=${encodeURIComponent(back)}`);
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
